<script setup lang="ts">
import { EllipsisVerticalIcon } from '@heroicons/vue/24/solid'

interface Props {
  class?: string
  size?: 'sm' | 'md' | 'lg'
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md'
})

const sizeClasses = {
  sm: 'w-3 h-3',
  md: 'w-4 h-4',
  lg: 'w-5 h-5'
}

const containerSizes = {
  sm: 'w-6 h-3',
  md: 'w-8 h-4',
  lg: 'w-10 h-5'
}

const spacingClasses = {
  sm: '-space-x-2',
  md: '-space-x-3',
  lg: '-space-x-4'
}
</script>

<template>
  <div class="flex flex-col items-center justify-center" :class="[containerSizes[size], props.class]">
    <div class="flex flex-row items-center" :class="spacingClasses[size]">
      <EllipsisVerticalIcon :class="sizeClasses[size]" />
      <EllipsisVerticalIcon :class="sizeClasses[size]" />
    </div>
  </div>
</template>
